//AgConnexion Panel
import './smartfarm-form.scss';

class SmartfarmForm {

  components;
  panel;
  overlay;
  formButtonSelector;
  formSelector;

  constructor(componentsSelector, panelSelector, overlaySelector, formButtonSelector, formSelector) {
    if (document.querySelectorAll(componentsSelector)) {
      this.components = document.querySelectorAll(componentsSelector);
      this.panel = document.querySelector(panelSelector);
      this.overlay = document.querySelector(overlaySelector);
      this.formButtonSelector = document.querySelector(formButtonSelector);
      this.formSelector = document.querySelector(formSelector);

    }
  }

  init() {
    this.components.forEach((component) => {
      component.addEventListener('click', () => {
        if (this.panel.classList.contains('open')) {
          this.panel.classList.remove('open');
          this.overlay.style.display = 'none';
          document.body.classList.remove('prevent-scroll');
        } else {
          this.panel.classList.add('open');
          this.overlay.style.display = 'block';
          document.body.classList.add('prevent-scroll');
        }
      });
    });
    //Remove client side validation as Drupal will always break it if form is used...
    //this.formButtonSelector.addEventListener('click', this.validateForm.bind(this), true);
  }

  validateForm(_e) {
    _e.preventDefault();
    let emailSelector = document.getElementById('smartfarm-form__email');
    let passwordSelector = document.getElementById('smartfarm-form__password');
    let validEmailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    let hasError = false;
    emailSelector.nextElementSibling.classList.add('has-error');

    if (!emailSelector.value.match(validEmailRegex)) {
      emailSelector.nextElementSibling.classList.add('has-error');
      hasError = true;
    } else {
      emailSelector.nextElementSibling.classList.remove('has-error');
    }

    if (passwordSelector.value === '') {
      emailSelector.nextElementSibling.classList.add('has-error');
      hasError = true;
    } else {
      emailSelector.nextElementSibling.classList.remove('has-error');
    }

    if (!hasError) {
      this.formSelector.submit();
    }
  }
}

window.addEventListener('load', () => {
  let sf = new SmartfarmForm('.smartfarm-form-toggle', '.smartfarm-form-container', '#smartfarm-form-selector-overlay', '.js-form-submit__smartfarm', '#smartfarm-form__form');
  sf.init();
});
